"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formik = require("formik");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faTimes = require("@fortawesome/pro-regular-svg-icons/faTimes");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _FormGroup = _interopRequireDefault(require("../FormGroup"));

var _excluded = ["name", "label", "help", "tooltip", "placeholder", "options", "setFieldValue", "handleChange", "className", "showWhen", "defaultValue", "allowClear", "testId", "testIdItems", "required"];

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ClearButton = _styledComponents["default"].button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    white-space: nowrap;\n"])));

var Option = function Option(props) {
  var dataProp = {
    innerProps: _objectSpread({
      'data-testid': props.data.label.toLowerCase().replaceAll(' ', '-')
    }, props.innerProps)
  };
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Option, _objectSpread(_objectSpread({}, props), dataProp));
};

var Tags = function Tags(_ref) {
  var name = _ref.name,
      label = _ref.label,
      help = _ref.help,
      tooltip = _ref.tooltip,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? false : _ref$placeholder,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      setFieldValue = _ref.setFieldValue,
      _ref$handleChange = _ref.handleChange,
      handleChange = _ref$handleChange === void 0 ? function () {} : _ref$handleChange,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      showWhen = _ref.showWhen,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
      _ref$allowClear = _ref.allowClear,
      allowClear = _ref$allowClear === void 0 ? false : _ref$allowClear,
      testId = _ref.testId,
      testIdItems = _ref.testIdItems,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? null : _ref$required,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name
  }, function (_ref2) {
    var field = _ref2.field,
        form = _ref2.form;
    var error = (0, _formik.getIn)(form.errors, name);

    if (error) {
      var errorFieldName = label ? label : 'This';
      error = error.replace(field.name, errorFieldName);
    }

    if (showWhen) {
      var showField = form.values.hasOwnProperty(showWhen) ? form.values[showWhen] : false;

      if (!showField) {
        return null;
      }
    }

    props.className = (0, _classnames["default"])(className);

    if (help) {
      props['aria-describedby'] = "".concat(name, "Help");
    }

    if (allowClear) {
      options.unshift({
        label: placeholder || 'Please Select...',
        value: ''
      });
    }

    var getTagValues = function getTagValues() {
      var _values;

      var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var results = [];

      if (typeof values === 'string') {
        var parsedValues = values;

        if (values[0] === '[') {
          // If the array is coming through as a string then parse it
          parsedValues = JSON.parse(values);
        } else {
          // avoid breaking backwards compatibility for fields that were a single <select> value
          parsedValues = [values];
        }

        values = parsedValues;
      }

      if (options && ((_values = values) === null || _values === void 0 ? void 0 : _values.length) > 0) {
        var _values2;

        results = (_values2 = values) === null || _values2 === void 0 ? void 0 : _values2.map(function (fieldVal) {
          return options.find(function (option) {
            return option.value === fieldVal;
          });
        });
      }

      return results;
    };

    (0, _react.useEffect)(function () {
      var temp = document.getElementsByClassName('list__multi-value__label');

      if (temp.length > 0) {
        for (var index = 0; index < temp.length; index++) {
          var t1 = document.getElementsByClassName('list__multi-value__label')[index];
          var t2 = document.createAttribute('data-testid');
          t2.value = "".concat(temp[index].innerHTML.toLowerCase().replaceAll(' ', '-'), "-multiselect-tag");
          t1.setAttributeNode(t2);
        }
      }
    });
    return /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
      name: name,
      label: label,
      help: help,
      tooltip: tooltip,
      error: error,
      required: required
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "d-flex align-items-center justify-content-between",
      "data-testid": "".concat(label.toLowerCase().replaceAll(' ', '-'), "-tags")
    }, /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], {
      components: {
        Option: Option
      },
      className: "w-100",
      classNamePrefix: "list",
      closeMenuOnSelect: false,
      isDisabled: form.isSubmitting || props.disabled,
      name: name,
      value: getTagValues(field.value),
      defaultValue: defaultValue,
      onChange: function onChange(option) {
        form.setFieldValue(field.name, option ? option.map(function (opt) {
          return opt.value;
        }) : []);
        handleChange(option ? option.value : []);
      },
      onBlur: field.onBlur,
      options: options,
      placeholder: placeholder || 'Please Select...',
      isMulti: true
    }), allowClear && /*#__PURE__*/_react["default"].createElement(ClearButton, {
      className: "btn btn-link",
      onClick: function onClick(e) {
        e.preventDefault();
        form.setFieldValue(field.name, '');
        handleChange('');
      },
      "data-testId": "clear-".concat(field.name.toLowerCase().replaceAll(' ', '-'))
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faTimes.faTimes,
      className: "mr-2"
    }), "Clear Value")));
  });
};

Tags.displayName = 'Tags';
Tags.propTypes = {
  name: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  help: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  placeholder: _propTypes["default"].string,
  options: _propTypes["default"].array.isRequired,
  className: _propTypes["default"].string
};
var _default = Tags;
exports["default"] = _default;